import { Range, Editor, Transforms, Path } from 'slate';
import { isListItem, createListItemElement, createListElement, isList } from '../utilities.mjs';
import { findAllNodesSafe } from '../../../../../core/queries/findNode.mjs';

function insertList(editor, options) {
  let {
    at = editor.selection
  } = options;
  if (Range.isRange(at)) {
    at = Editor.unhangRange(editor, at);
  }
  if (!at) {
    return;
  }
  const futureListItems = findAllNodesSafe(editor, {
    at,
    match: (node, path) => {
      if (Path.isChild(path, [0])) {
        // Any top level node that's not a list should become a list item
        return !isList(node);
      }
      // Selected list items have to be moved to the new list
      return isListItem(node);
    }
  });
  const futureListItemsRefs = futureListItems.map(([node, path]) => ({
    node,
    pathRef: Editor.pathRef(editor, path)
  }));

  // Track selection as transforms are applied. This is so "wrapNodes" still affects the correct nodes at the end
  const selectionRef = at === editor.selection ? Editor.rangeRef(editor, at) : null;
  if (futureListItemsRefs.length > 0) {
    Editor.withoutNormalizing(editor, () => {
      var _selectionRef$current;
      futureListItemsRefs.forEach(({
        node,
        pathRef
      }) => {
        if (pathRef.current) {
          if (isListItem(node)) {
            // Selected list items are lifted out of their list so that they can be wrapped with the new list
            // Any remaining empty lists will be removed by normalization
            Transforms.liftNodes(editor, {
              at: pathRef.current,
              match: isListItem
            });
          } else {
            Transforms.wrapNodes(editor, createListItemElement([]), {
              at: pathRef.current
            });
          }
        }
        pathRef.unref();
      });
      const location = (_selectionRef$current = selectionRef === null || selectionRef === void 0 ? void 0 : selectionRef.current) !== null && _selectionRef$current !== void 0 ? _selectionRef$current : at;
      if (!location) {
        return;
      }
      Transforms.wrapNodes(editor, createListElement(options.listType), {
        at: location,
        match: isListItem
      });
    });
  }
  selectionRef === null || selectionRef === void 0 ? void 0 : selectionRef.unref();
}

export { insertList };
